import { useMemo } from 'react';
import { DateFormatter } from '@internationalized/date';
import { I18n } from '~/common/explicit-exports';

export function useDateFormatter(options?: Intl.DateTimeFormatOptions) {
  const locale = I18n.currentLocale().replace(/_/g, '-');
  return useMemo(() => new DateFormatter(locale, options), [locale, options]);
}
